import { useContext } from 'react';
import { I18nContext, type I18nContextType } from '../providers/I18nProvider';

/**
 * Custom hook to access the current i18n context.
 * @returns The current i18n context value.
 */
const useI18n = (): I18nContextType => {
  const ctx = useContext(I18nContext);

  if (!ctx) {
    throw new Error('useI18n must be used within an I18nProvider');
  }

  return ctx;
};

export default useI18n;
